<template>
  <b-modal
    :id="id"
    :title="trans('message')"
    size="xl"
    hide-footer
    no-enforce-focus
    no-close-on-backdrop
  >
    <send-out
      ref="send_out"
      :organization="organization"
      :user="user"
      :rl24="rl24"
      :initial_type="type"
      :initial_subject="subject"
      :initial_body="body"
      :initial_message_sample_id="messageSampleId"
      :initial_template_id="templateId"
      :initial_comtype="comtype"
      :invoice_no="invoice_no"
      :initial_attach_invoice="!!invoice_no || attachPdfInvoice"
      :can-attach-pdf-invoice="canAttachPdfInvoice"
      :invoice_is_contract="invoice_is_contract"
      :hide-message-both-parents="hideMessageBothParents"
      :ucid="ucid"
      :initial_use="prefilled_form_url || ucid && !invoice_is_contract ? 'shorten_url' : (!!paper_id ? 'paper' : undefined)"
      :initial_use_url="prefilled_form_url ? prefilled_form_url : (ucid && !invoice_is_contract ? cartUrl(organization, ucid) : undefined)"
      :initial_use_url_cta="prefilled_form_url ? trans('fill_form') : (ucid && !invoice_is_contract ? trans('shopping_cart') : undefined)"
      :initial_paper_id="paper_id"
      :recipient_list_id="recipient_list_id"
      :people="people"
      :hide-scheduling="hideScheduling"
      :context="context"
      no-redirect
      :can-attach-pdf-recipient-list="canAttachPdfRecipientList"
      :can-attach-pdf-tickets="canAttachPdfTickets"
      :attach-pdf="attachPdf"
      :allow-dups="allowDups"
      @cancel="onCancelConfirm"
      @sent="onSent"
      @scheduled="onSent"
    ></send-out>
    <confirm-modal
      id='confirm-cancel-modal'
      size="md"
      :title="trans('confirm_cancel')"
      :okTitle="trans('confirm_cancel')"
      :message="trans('confirm_message_cancel')"
      @confirm="onCancel"
    ></confirm-modal>
  </b-modal>
</template>

<script>
  import SendOut from './../sendout/SendOutComponent'
  import ConfirmModal from '../../../common/components/ConfirmModal'

  export default {
    props: {
      id: {
        type: String,
        default: 'send-message-modal',
      },
      organization: Object,
      user: Object,
      rl24: Object,
      type: {
        type: String,
        default: 'both',
      },
      subject: String,
      body: String,
      messageSampleId: String,
      templateId: Number,
      ucid: String,
      invoice_no: Number,
      prefilled_form_url: String,
      invoice_is_contract: Boolean,
      canAttachPdfInvoice: Boolean,
      canAttachPdfTickets: {
        type: Boolean,
        default: false
      },
      attachPdfInvoice: {
        type: Boolean,
        default: false,
      },
      comtype: {
        type: String,
        default: 'reminders',
      },
      people: Array,
      recipient_list_id: Number,
      hideScheduling: {
        type: Boolean,
        default: false,
      },
      context: Object,
      paper_id: Number,
      canAttachPdfRecipientList: Object,
      attachPdf: {
        type: Boolean,
        default: false,
      },
      hideMessageBothParents: {
        type: Boolean,
        default: false,
      },
      allowDups: Boolean,
    },
    components: {
      SendOut,
      ConfirmModal
    },
    data() {
      return {
        trans: trans,
        moment: moment,
        cartUrl: _.cartUrl,
      }
    },
    computed: {
    },
    methods: {
      onCancel() {
        this.$bvModal.hide(this.id)
      },
      onCancelConfirm() {
        this.$bvModal.show('confirm-cancel-modal')
      },
      onSent(send_out) {
        this.$emit('sent', send_out)
        this.$bvModal.hide(this.id)
      },
    },
    mounted() {
      window[_.camelCase(this.id)] = this
    },
  }
</script>